"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIZARD_COLLECTION_COLOR_INT_TO_COLLECTION_COLOR_INT_MAP = exports.COLOR_NAME_TO_COLLECTION_COLOR_INT_MAP = exports.COLOR_NAME_TO_CLASS_NAME_MAP = exports.COLLECTION_COLOR_INT_TO_COLOR_NAME_MAP = exports.COLLECTION_COLOR_INT_TO_CLASS_NAME_MAP = void 0;
// Vars
var COLLECTION_COLOR_INT_TO_COLOR_NAME_MAP = {
  1: 'Trace',
  2: 'Confirmed',
  3: 'Warning',
  4: 'Rust',
  5: 'Error',
  6: 'Grey1',
  7: 'Sky'
};
exports.COLLECTION_COLOR_INT_TO_COLOR_NAME_MAP = COLLECTION_COLOR_INT_TO_COLOR_NAME_MAP;
var COLOR_NAME_TO_COLLECTION_COLOR_INT_MAP = {
  'Trace': 1,
  'Confirmed': 2,
  'Warning': 3,
  'Rust': 4,
  'Error': 5,
  'Grey1': 6,
  'Sky': 7
};
exports.COLOR_NAME_TO_COLLECTION_COLOR_INT_MAP = COLOR_NAME_TO_COLLECTION_COLOR_INT_MAP;
var COLOR_NAME_TO_CLASS_NAME_MAP = {
  'Trace': 'bg-trace-color',
  'Confirmed': 'bg-confirmed-card',
  'Warning': 'bg-warning-color',
  'Rust': 'bg-rust-color',
  'Error': 'bg-error-color',
  'RustShade': 'bg-rustshade-color',
  'Grey1': 'bg-grey1-color',
  'Sky': 'bg-sky-color'
};
exports.COLOR_NAME_TO_CLASS_NAME_MAP = COLOR_NAME_TO_CLASS_NAME_MAP;
var COLLECTION_COLOR_INT_TO_CLASS_NAME_MAP = {
  1: 'bg-trace-color',
  2: 'bg-confirmed-color',
  3: 'bg-warning-color',
  4: 'bg-rust-color',
  5: 'bg-error-color',
  6: 'bg-grey1-color',
  7: 'bg-sky-color'
};
exports.COLLECTION_COLOR_INT_TO_CLASS_NAME_MAP = COLLECTION_COLOR_INT_TO_CLASS_NAME_MAP;
var WIZARD_COLLECTION_COLOR_INT_TO_COLLECTION_COLOR_INT_MAP = {
  0: 4,
  1: 7,
  2: 2,
  3: 3
};
exports.WIZARD_COLLECTION_COLOR_INT_TO_COLLECTION_COLOR_INT_MAP = WIZARD_COLLECTION_COLOR_INT_TO_COLLECTION_COLOR_INT_MAP;